/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Npm
import React from 'react';

// Core
import { Router } from '@app';
import { Input, Link, Button } from '@client/components';

// Types
import type { TDomainsList } from '@/server/services/Domains';
import type { domains as Domain } from '@models/types';

// App
import Page from '@/client/pages/landing/_layout/_page';
import Screenshot from '@/client/assets/img/illustrations/screenshot.jpg';

/*----------------------------------
- CONTROLEUR
----------------------------------*/
Router.page('/', { static: true }, ({ }) => {

    /*----------------------------------
    - INIT
    ----------------------------------*/

   

    /*----------------------------------
    - ACTIONS
    ----------------------------------*/

    /*----------------------------------
    - RENDER
    ----------------------------------*/
    //const Marquee = MarqueeComponent ? MarqueeComponent.default : 'div';
    return (
        <Page
            title="Unique Domains - Find the highest potential domains for your business"
            description="Access all the most valuable and brandable domain names that are still available to buy, and find a highly memorable and SEO-friendly name for your business."
            //header={( <DomainFilters /> )}
        >

            <header class="col al-center" style={{ 
                padding: '5vh 0' 
            }}>
                <div class="w-a-5 col">

                    <h1 style={{ fontSize: '3rem' }}>
                        A Domain Name can change <strong>Everything</strong>.
                    </h1>

                    <p class="reading">
                        Unique Domains sweeps the web to spot short, memorable names before anyone else, analyzes their price, popularity, and brand potential, and delivers the perfect domains to you.
                    </p>

                    <div class="row al-center sp-05 mgt-05">
                        <Button type="primary" shape="pill"
                                link="/user/signup">
                            I'm a founder
                        </Button>
                        <Button type="secondary" shape="pill"
                            link="/user/signup">
                            I'm an investor
                        </Button>
                    </div>
                </div>
            </header>

            <div class="motion">
                <img src={Screenshot} />
            </div>

            {/* <div class="col al-left">
                <h1 class="w-3-7">
                    Find the Domain Name that will <strong><span>Drive</span> <span>your</span> Growth</strong>.
                </h1>
            </div>

            <p class="reading">
                Unique.Domains is the largest and most updated database of one word domain names of the world.
            </p>

            <ul class="row al-left al-fill scrollable">
                <li class="col al-left card pdh-1" style={{ minWidth: '220px', flex: '0 0 220px' }}>
                    <i src="coins" class="fg primary" />
                    <p class="txt-left">
                        <strong>Acquire a strong asset</strong> that boosts business value and can be resold at a higher price.
                    </p>
                </li>
                <li class="col al-left card pdh-1" style={{ minWidth: '220px', flex: '0 0 220px' }}>
                    <i src="brain" class="fg primary" />
                    <p class="txt-left">
                        <strong>Stay in people's mind</strong> through a memorable name that exudes trust.
                    </p>
                </li>
                <li class="col al-left card pdh-1" style={{ minWidth: '220px', flex: '0 0 220px' }}>
                    <i src="magnet" class="fg primary" />
                    <p class="txt-left">
                        <strong>Dominate search engines</strong>, turn them into a long-term user acquisition source.
                    </p>
                </li>
            </ul> */}
          
        </Page>
    )
});